export enum MIXPANEL_DEFAULT_VALUES {
  NOT_AVAILABLE = 'N/A'
}
